module.exports = __webpack_public_path__ + "static/media/Laos.72bd623f.png";